import { SlackChannels } from '../enums/SlackChannels'
import { GOOGLE_CHAT_WEBHOOKS } from '../enums/GoogleChatEnums'

/**
 * Send a message to Google Chat via webhook.
 * Only sends if:
 * 1. enabled is true
 * 2. A webhook URL exists for the given channel
 *
 * @deprecated Google Chat notifications are disabled. Use Slack via notify() instead.
 *
 * @param text - The message text to send
 * @param channel - The SlackChannels enum value (maps to Google Chat webhook)
 * @param enabled - Whether Google Chat is enabled (from config)
 */
export const sendToGoogleChat = (text: string, channel: SlackChannels, enabled: boolean): Promise<void> => {
  if (!enabled) {
    return Promise.resolve()
  }

  const webhookUrl = GOOGLE_CHAT_WEBHOOKS[channel]
  if (!webhookUrl) return Promise.resolve() // No webhook for this channel, skip silently

  return fetch(webhookUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text })
  })
    .then(() => undefined)
    .catch((err) => {
      console.error(`Google Chat message could not be sent to ${channel}: ${text}, error: ${err?.message || err}`)
    })
}
